
Directives.EditableHeaderBillToDirective = function EditableHeaderBillToDirective() {

    // @ngInject
    function EditableHeaderBillToDirectiveControllerFunc($injector, $scope, WorkspaceFilesManager, _, ModalService, UsersManager, PreviewModeService, AnalyticsService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'EditableHeaderBillToDirectiveController';

        this.$scope = $scope;
        this.ModalService = ModalService;
        this._ = _;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.AnalyticsService = AnalyticsService;

        this.user = UsersManager.getCurrUser();
        this.isPreviewMode = PreviewModeService.isInPreviewMode();
        this.billTo = null;
        this.members = [];

        this.register(this.fileModel, 'success', function success() {
            this.$scope.$applyAsync(function () {
                this.loadModel();
            }.bind(this));
        }.bind(this));
    }

    var EditableHeaderBillToDirectiveController = Class(Controllers.BaseController, {
        constructor: EditableHeaderBillToDirectiveControllerFunc,

        loadModel: function loadModel() {
            this.members = this.fileModel.users;
            this._getFileClients();
            if (this.fileModel.bill_to) {
                this.billTo = this._.find(this.members, function (member) {
                    return member._id === this.fileModel.bill_to;
                }.bind(this));
            }
        },

        onMemberSelected: function onMemberSelected(member, isFromAddParticipant) {

            // save current state for analytics
            var wasBillToFilled = !!this.billTo;

            this.billTo = member;
            this.WorkspaceFilesManager.setWorkspaceFileBillTo(this.fileModel, this.billTo);
            this.closeDropdown();

            // analytics
            var analyticsArgs = {
                is_edit: wasBillToFilled
            };

            if(!!isFromAddParticipant) {
                analyticsArgs.is_add_participant = true;
            }

            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.file_bill_to_set_client, analyticsArgs);
        },

        dropdownToggle: function dropdownToggle() {
            if (this.isEditable) {
                this.isDropdownActive = !this.isDropdownActive;

                if(this.isDropdownActive) {
                    var hasBillTo = !!this.billTo;
                    this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.file_bill_to_set_client, {is_edit: hasBillTo});
                }

            }
        },

        closeDropdown: function closeDropdown() {
            this.isDropdownActive = false;
        },

        clearBillTo: function clearBillTo() {
            this.billTo = null;
            this.closeDropdown();
            this.WorkspaceFilesManager.deleteWorkspaceFileBillTo(this.fileModel);
        },

        openAddParticipantModal: function openAddParticipantModal() {
            this.ModalService.openAddWorkspaceParticipantModal(this.workspace).then(function editSuccess(addMemberResp) {
                this.workspace.members.push(addMemberResp.user);
                this.WorkspaceFilesManager.getWorkspaceFileMembers(this.fileModel).then(function success() {

                    this.loadModel();

                    var client = this._.find(this.members, function (member) {
                        return member._id === addMemberResp.user._id;
                    }.bind(this));
                    this.onMemberSelected(client, true);
                }.bind(this));
            }.bind(this));
        },

        _getFileClients: function _getFileClients() {
            this.clients = this.members.filter(function filterFileClients(user) {
                return !user.company || user.company._id !== this.fileModel.owner.company._id;
            }.bind(this));
        },
    });

    return {
        scope: {
            fileModel: '=',
            isEditableMode: '=',
            isEditable: '=',
            workspace: '='
        },
        templateUrl: 'angular/app/modules/core/features/workspace_file/editable_header/bill_to/editable_header_bill_to_template.html',
        controller: EditableHeaderBillToDirectiveController,
        controllerAs: 'billToVm',
        bindToController: true
    };
};
